<template>
  <!-- 个人贷款额度合同 -->
  <div class="protocol">
    <navigation ></navigation>
    <section class="header ">确认书</section>
    <section class="content">
      <p class="text tab-2"><b>重要提示：</b></p>
      <p class="text tab-2"><b>为了维护您的合法权益，在您确认签署本确认书之前，请您务必仔细阅读本确认书的全部内容（特别是字体加粗或下划线标注内容），关注您的权利与义务。如您不同意本确认书的内容，或对本确认书任何条款持有异议，请不要进行签署或点击确认及后续操作。本确认书一经签署或点击确认即视为您已完全理解并同意本确认书的全部条款。</b></p>
      <p class="text tab-2">确认人就其通过网络服务平台（包括但不限于天美贷APP等，以下简称“平台”）申请的服务或产品（以下简称“订单”）相关事宜确认如下：</p>
      <p class="text tab-2"><b>1、确认人已充分理解并认可平台就确认人提出的异议事项所涉解决方案，且确认人承诺就前述解决方案履行保密义务，不得以任何方式向任何第三方披露解决方案。</b></p>
      <p class="text tab-2"><u class="underline">2、确认人保证签署本确认书之后，确认人不得以任何理由向平台或平台关联方主张订单相关权利。</u></p>
      <p class="text tab-2"><u class="underline">3、确认人保证将在接受解决方案后撤回订单相关异议申请（包括但不限于向平台撤回投诉、向监管部门撤回投诉等）。</u></p>
      <p class="text tab-2">4、确认人已充分阅读并理解本确认书全文，确认系本人的真实意思表示，经本人签署后即具有法律效力。</p>
      <p class="text tab-2"> 确认人（签名）：</p>
      <p class="text tab-2">身份证号码：</p>
      <p class="text tab-2">日期：</p>
    </section>

  </div>
</template>
<script>
export default {
  created () {
    this.$bus.$emit('ready')
  }
}
</script>